import React, { useEffect } from "react";
import { ACH, CreditCard } from "@resources";
import { useLocation, useNavigate } from 'react-router-dom';
import { helpers, Enums } from "@shared";
import { Resident } from "@common";

const PaymentMethodSelector = () => {

    const navigate = useNavigate(), location = useLocation();

    const {
        state: {
            account: {
                residentName,
                accountPreferences: { paymentTypeFees }
            },
            hasMultipleAccounts
        }
    } = location;

    const selectOption = (selection) => {
        helpers.navigateNext(location, navigate, undefined, { selectedPaymentType: selection });
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const achFee = paymentTypeFees.find(p => p.idPaymentType === Enums.PaymentType.ACH);
    const ccFee = paymentTypeFees.find(p => p.idPaymentType === Enums.PaymentType.Card);

    let resident;
    if (hasMultipleAccounts === true) {
        resident = (<div className="w-10/12 self-center"><Resident residentName={residentName} /></div>);
    }

    return (
        <div className="page-content-wrapper">
            <h1 className="page-header">Add payment method</h1>
            <span className="page-subheader">We will use this for online payments</span>
            <div className="mt-4 flex flex-col gap-y-7">
                {resident}
                {
                    achFee &&
                    <div className="flex flex-row bg-sb-bg p-2 px-6 gap-y-2 rounded-xl border-2 border-gray-200 w-full cursor-pointer" onClick={() => selectOption(Enums.PaymentType.ACH)}>
                        <div className="flex flex-col">
                            <span className="font-bold text-lg">Checking/Savings Account</span>
                            <span>{`Payments from a checking or savings account incur a ${helpers.printFeeRule(achFee)} ACH processing fee`}</span>
                        </div>
                        <ACH className="w-20 flex-none" />
                    </div>
                }
                {
                    ccFee &&
                    <div className="flex flex-row bg-sb-bg p-2 px-6 gap-y-2 rounded-xl border-2 border-gray-200 w-full cursor-pointer" onClick={() => selectOption(Enums.PaymentType.Card)}>
                        <div className="flex flex-col">
                            <span className="font-bold text-lg">Credit/Debit Card</span>
                            <span>{`Payments from a credit/debit card incur a ${helpers.printFeeRule(ccFee)} processing fee`}</span>
                        </div>
                        <CreditCard className="w-20 flex-none" />
                    </div>
                }
            </div>
        </div >
    );
};

export default PaymentMethodSelector;